import SpendingDemandListFilterPresenter from "./SpendingDemandListFilterPresenter";

/**
 * Filtre des demandes de dépenses adapté à la vue User.
 * Réutilise SpendingDemandListFilterPresenter avec forUser=true pour masquer
 * le filtre Utilisateur (l'utilisateur ne voit que ses propres demandes).
 */
export default function SpendingDemandUserPresenterFilter() {
  return <SpendingDemandListFilterPresenter forUser />;
}
